import type { LineString, Polygon, Position } from "geojson";
import type { ControlPosition, PositionAnchor } from "maplibre-gl";

export type MapLibreOptions = {
	showNav?: boolean;
	navPosition?: ControlPosition;
	restoreView?: boolean;
	maxRestoredZoom?: number;
	defaultMapCenter?: Position;
	minZoom?: number;
	maxZoom?: number;
	initialZoom?: number;
	initialBearing?: number;
	initialPitch?: number;
	condensedAttribution?: boolean;
	attributionPosition?: ControlPosition;
};

export type MarkerLabel = {
	anchor?: PositionAnchor;
};

export type Marker = {
	location: Position;
	icon?: string;
	bearing?: number;
	draggable?: boolean;
	rotateable?: boolean;
	snapToRoute?: LineString;
	ghostMarker?: boolean;
	snapOffset?: number;
	dragConstraint?: Polygon;
	bearingIndicator?: string;
	rotationInitialBearing?: number;
	rotationVariant?: "default" | "error";
};

type Layer = {
	minZoom?: number;
	maxZoom?: number;
};

export type Stroke = {
	color: string;
	weight: number;
	opacity: number;
	dashArray?: number[];
	cap?: "butt" | "round" | "square";
} & Layer;

export type LineSymbol = {
	color: string;
	symbol?: string;
	size?: number;
	spacing?: number;
	offset?: [number, number];
} & Layer;

export type Fill = {
	opacity: number;
	color?: string;
	pattern?: string;
} & Layer;

export type Extrusion = {
	height: number;
	base?: number;
} & Fill &
	Layer;

export function isExtrusion(layer: Fill | Extrusion): layer is Extrusion {
	return layer && "height" in layer && typeof layer.height === "number";
}

export type Circle = {
	opacity: number;
	radius: number;
	color: string;
	stroke?: Stroke;
} & Layer;

export type RasterOptions = {
	opacity?: number;
	fadeDuration?: number;
} & Layer;

export type ImageOverlay = {
	image: string; // base64
	ne: Position;
	sw: Position;
};
